var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28515 16L11.8566 16C11.9352 16 11.9994 15.9357 11.9994 15.8571V14.8571C11.9994 14.7786 11.9352 14.7143 11.8566 14.7143L2.99944 14.7143L2.99944 2.42857C2.99944 2.35 2.93515 2.28571 2.85658 2.28571H1.85658C1.77801 2.28571 1.71373 2.35 1.71373 2.42857L1.71373 15.4286C1.71373 15.7446 1.96908 16 2.28515 16ZM4.57087 13.7143L13.7137 13.7143C14.0298 13.7143 14.2852 13.4589 14.2852 13.1429L14.2852 3.66607C14.2852 3.51428 14.2244 3.36964 14.1173 3.2625L11.0227 0.167857C10.9834 0.128571 10.9387 0.0964283 10.8905 0.0696426V0.0357136H10.8155C10.753 0.0124993 10.6869 -7.15256e-07 10.6191 -7.15256e-07H4.57087C4.2548 -7.15256e-07 3.99944 0.255356 3.99944 0.571428L3.99944 13.1429C3.99944 13.4589 4.2548 13.7143 4.57087 13.7143ZM10.8923 1.85357L12.4298 3.39286H10.8923V1.85357ZM5.28515 1.28571L9.74944 1.28571V3.82143C9.74944 4.21607 10.0691 4.53571 10.4637 4.53571H12.9994L12.9994 12.4286H5.28515L5.28515 1.28571Z",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.1a494271ff84842cb237e5a761d6c2d3.svg";
export { ForwardRef as ReactComponent };